import { Timeframe } from "../Timeframe";

interface IServicePublishingConfig {
    rule: ServicePublishingRule;
    timeframe: Timeframe;
}

enum ServicePublishingRule {
    Immediate = 0,
    StartOfDay = 1,
    FullDay = 2,
    Continuously = 3
}

export { IServicePublishingConfig, ServicePublishingRule };
